var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitterGradient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 30.7393V70.4238C0.593804 72.2345 1.09627 74.0134 2.05067 75.5814C3.00507 77.1497 4.3778 78.4518 6.03084 79.3572L42.2581 99.1995C43.9112 100.105 45.7865 100.582 47.6952 100.582C49.6041 100.582 51.4791 100.105 53.1322 99.1995L89.3596 79.3572C91.0127 78.4518 92.3853 77.1497 93.3398 75.5814C94.2943 74.0134 94.7966 72.2345 94.7966 70.4238V30.7393C94.7966 28.9286 94.2943 27.1497 93.3398 25.5817C92.3853 24.0134 91.0127 22.7112 89.3596 21.8059L53.1322 1.96358C51.4791 1.05819 49.6041 0.581543 47.6952 0.581543C45.7865 0.581543 43.9112 1.05819 42.2581 1.96358L6.03084 21.8059C4.3778 22.7112 3.00507 24.0134 2.05067 25.5817C1.09627 27.1497 0.593804 28.9286 0.59375 30.7393Z",
    fill: "#4375C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59821 74.6396L3.59815 74.6395C2.814 73.3512 2.40539 71.8974 2.40534 70.4238V30.7393C2.40534 30.7393 2.40534 30.7393 2.40534 30.7393C2.4054 29.2656 2.81401 27.8118 3.59815 26.5236L3.59821 26.5235C4.38291 25.2341 5.51882 24.1518 6.90108 23.3947L6.03084 21.8059L6.90109 23.3947L43.1283 3.55248C43.1283 3.55247 43.1283 3.55246 43.1283 3.55245C44.5112 2.79512 46.0866 2.39314 47.6952 2.39314C49.304 2.39314 50.8791 2.79511 52.262 3.55246C52.262 3.55247 52.262 3.55247 52.262 3.55248L88.4893 23.3947L88.4894 23.3948C89.8717 24.1518 91.0075 25.234 91.7923 26.5235L91.7924 26.5236C92.5765 27.8118 92.9851 29.2656 92.9851 30.7393V70.4238C92.9851 71.8975 92.5765 73.3512 91.7924 74.6395L91.7923 74.6395C91.0075 75.929 89.8717 77.0112 88.4893 77.7683L52.262 97.6106C50.8792 98.368 49.304 98.77 47.6952 98.77C46.0866 98.77 44.5111 98.368 43.1283 97.6106L6.90114 77.7684C5.5188 77.0112 4.38289 75.929 3.59821 74.6396Z",
    stroke: "url(#paint0_linear_13440_32886)",
    strokeWidth: 3.62319
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2354 39.5268C63.9242 40.1078 62.5156 40.5004 61.0349 40.6779C62.5628 39.7636 63.7059 38.3247 64.2508 36.6296C62.8153 37.4823 61.2442 38.0825 59.6059 38.4041C58.5041 37.2277 57.0448 36.448 55.4545 36.186C53.8642 35.924 52.2319 36.1943 50.811 36.9551C49.3901 37.7158 48.2601 38.9244 47.5964 40.3932C46.9328 41.8619 46.7726 43.5087 47.1408 45.0779C44.2321 44.9318 41.3866 44.1758 38.789 42.8589C36.1914 41.5419 33.8997 39.6935 32.0627 37.4336C31.4346 38.5171 31.0734 39.7734 31.0734 41.1113C31.0727 42.3157 31.3693 43.5017 31.9369 44.564C32.5045 45.6262 33.3255 46.532 34.3271 47.2009C33.1655 47.164 32.0296 46.8501 31.0138 46.2854V46.3796C31.0136 48.0689 31.598 49.7061 32.6676 51.0136C33.7372 52.3211 35.2262 53.2182 36.882 53.5528C35.8044 53.8444 34.6747 53.8874 33.5781 53.6784C34.0452 55.1319 34.9552 56.4029 36.1806 57.3136C37.4061 58.2242 38.8856 58.7288 40.412 58.7568C37.8208 60.791 34.6206 61.8944 31.3263 61.8895C30.7427 61.8897 30.1596 61.8556 29.5801 61.7875C32.924 63.9375 36.8166 65.0786 40.7921 65.0741C54.2496 65.0741 61.6064 53.9281 61.6064 44.2613C61.6064 43.9472 61.5986 43.63 61.5845 43.316C63.0155 42.2811 64.2507 40.9996 65.2323 39.5315L65.2354 39.5268Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13440_32886",
    x1: 0.593748,
    y1: 0.342359,
    x2: 115.186,
    y2: 63.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4195D2",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter_gradient.d30c4d93876cdb6798ba5c0b337d3437.svg";